import { Icon, Text, HStack, VStack, IconStatusNew } from '@genial/components';
import { Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../components/TableContent';
import { getFixedFeeColumnFlex } from '../../constants';
import { FixedFeeRelatedTerm } from '../FixedFeeRelatedTerm';
import { FixedFeeTermDetails } from '../FixedFeeTermDetails';
import { ContractDate } from '../shared/ContractDate';
import { FixedFeeRowActions } from '../shared/FixedFeeRowActions';
import { HasRelatedTermFlag } from '../shared/HasRelatedTermFlag';

import { FixedFeeTermsRowProps } from '.';

export const FixedFeeTermsRowDesktop: React.FC<FixedFeeTermsRowProps> = ({ item }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <VStack mx="inline.xxs">
      <TableContent
        direction="column"
        space={0}
        p="inset.sm"
        {...(expanded && { customShadowProps: { borderBottomRadius: '0' } })}>
        <HStack w="full" alignItems="center">
          <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(0)}>
            <HStack space="inline.quarck" alignItems="center">
              <TableContentItemText>{item.term}</TableContentItemText>
              <HasRelatedTermFlag hasRelatedTerm={!!item.relatedTerm} />
            </HStack>
            <IconStatusNew color={item.statusColor} icon={item.statusIcon} status={item.status} />
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(1)}>
            <TableContentItemText color="neutral.medium" fontSize="xs">
              {item.createDateNormalized}
            </TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(2)}>
            <TableContentItemText tooltip={item.customerName}>
              {item.customerName}
            </TableContentItemText>
            <Text color="neutral.medium" fontSize="xs">
              Conta de custódia {item.account}
            </Text>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(3)}>
            <TableContentItemText>{item.feeRate}</TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(4)}>
            <TableContentItemText>{item.equityExclusion}</TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(5)}>
            <TableContentItemText>{item.netWorth}</TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(6)}>
            <ContractDate
              waitingResponse={item.waitingResponse}
              contractDate={item.contractDateNormalized}
            />
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFixedFeeColumnFlex(7)}>
            <HStack alignItems="center" space="inline.xxxs" w="full">
              <Pressable onPress={handleToggleExpand}>
                <Icon
                  name={expanded ? 'ChevronUp' : 'ChevronDown'}
                  size="xxs"
                  color="brand.primary.principal"
                />
              </Pressable>
              <FixedFeeRowActions feeTerm={item} />
            </HStack>
          </TableContentItemColumn>
        </HStack>
        {expanded && <FixedFeeTermDetails fixedFeeTerm={item} />}
      </TableContent>
      {expanded && <FixedFeeRelatedTerm fixedFeeTerm={item} />}
    </VStack>
  );
};
